import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetPhone = IAction<EPaymentActions.SET_PHONE, string>

const setPhone = (phone: string): TSetPhone => ({
    type: EPaymentActions.SET_PHONE,
    payload: phone,
});

export default setPhone;
